/* eslint-disable sonarjs/cognitive-complexity */
/* eslint-disable sonarjs/no-collapsible-if */
/* eslint-disable sonarjs/prefer-immediate-return */
import * as TradingView from './charting_library';
import { PricedPoint } from './charting_library';
import { LineWidth, LineStyle } from "./config/smpa";
import { TVContext, tvbar } from './hub/context';

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface tvpoint {
    t: number;
    p: number;
}

export const valign_top = 'bottom';
export const valign_center = 'middle';
export const valign_bottom = 'top';
export const halign_right = 'right';
export const halign_left = 'left';
export const halign_center = 'center';
export const color_transparent = 'rgba(0,0,0,0.0)';
//const textOpacity = 0.6;
export function toTvPt(pt: tvpoint): TradingView.PricedPoint {
    return {
        time: pt.t,
        price: pt.p
    }
}
export function fromTvPt(pt: TradingView.PricedPoint): tvpoint {
    return {
        t: pt.time,
        p: pt.price
    }
}
///-1 dark 1 white
export function brightenColor(color: string, bright: number) {
    if (color == null)
        return "#000000";
    if (!(color.length == 7 || color.length == 9))
        return "#404040";
    let r = parseInt(color.substring(1, 3), 16);
    let g = parseInt(color.substring(3, 5), 16);
    let b = parseInt(color.substring(5, 7), 16);
    const ob = 1 - bright;
    bright = 1 + bright;
    r = Math.round(Math.min(255, r * bright));
    g = Math.round(Math.min(255, g * bright));
    b = Math.round(Math.min(255, b * bright));

    let a = 1.0;
    if (color.length == 9)
        a = parseInt(color.substring(7, 9), 16) / 255.0;
    a *= ob;
    return `rgba(${r},${g},${b},${Math.round((a) * 100) / 100.0})`;
}
export function isTransparent(color: string) {
    if (color == null) return true;
    if (color.length != 9)
        return false;
    let a = parseInt(color.substring(7, 9), 16);
    return a <= 5;
}
export function getColor(color: string, opacity: number = null, opacityOnExistent = false) {
    if (color == null)
        return "#000000";
    if (!(color.length == 7 || color.length == 9))
        return "#404040";
    const r = color.substring(1, 3);
    const g = color.substring(3, 5);
    const b = color.substring(5, 7);
    let a = 1.0;
    if (color.length == 9)
        a = parseInt(color.substring(7, 9), 16) / 255.0;
    if (opacity)
        a = Math.min(Math.max(0.0, opacityOnExistent ? a * opacity : opacity), 1.0);
    return `rgba(${parseInt(r, 16)},${parseInt(g, 16)},${parseInt(b, 16)},${Math.round((a) * 100) / 100.0})`;
}


export enum zOrderType {
    top = 'top',
    bottom = 'bottom'
};
export class dTool {
    id: TradingView.EntityId = null;
    symbol: string = null;
    resolution: string = null;
    ownerStudyId: TradingView.EntityId = null;
    toolType: TradingView.SupportedLineTools = null;
    //visible: boolean;
    editable: boolean;
    tvd: TVContext;
    zOrder: zOrderType = null;
    hasLabels = true;
    cachable = true;
    private tx: string;
    constructor(toolType: TradingView.SupportedLineTools, tvd: TVContext) {
        //this.visible = visible;
        this.toolType = toolType;
        this.tvd = tvd;
        this.zOrder = zOrderType.top;
        this.editable = false;
    }
    get isVisible() {
        return this.id != null;
    }
    getShape(): TradingView.ILineDataSourceApi {
        if (this.id == null)
            return null;
        try {
            return this.tvd.tv.activeChart().getShapeById(this.id);
        } catch (e) {
            //console.error(e);
            return null;
        }
    }

    setText(text: string) {
        if (text)
            this.setProperties({ 'text': text, showLabel: true });
        else
            this.setProperties({ showLabel: false });
        this.tx = text;
    }
    getText(): string {
        return this.tx;
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    private getShapeParams(): TradingView.CreateShapeOptions<object> {
        return {
            shape: this.toolType as any,
            lock: !this.editable,
            zOrder: this.zOrder,
            showInObjectsTree: false,
            disableSelection: !this.editable,
            disableSave: true,
            disableUndo: true,
            ownerStudyId: this.ownerStudyId,
            overrides: this.buildOverrides(),
            filled: false,
            icon: null,
            text: null
        };
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    setProperties(props: any) {
        const shape = this.getShape();
        if (!shape)
            return;
        shape.setProperties(props);
    }

    getPoints() {
        const shape = this.getShape();
        if (!shape)
            return [];
        return shape.getPoints().map(fromTvPt);
    }
    setPoints(pts: tvpoint[]) {
        const shape = this.getShape();
        if (shape)
            shape.setPoints(pts.map(toTvPt));
    }
    getStartTime() {
        const points = this.getPoints();
        if (points.length == 0)
            return 0;
        return points[0].t;
    }
    getStartPrice() {
        const points = this.getPoints();
        if (points.length == 0)
            return 0;
        return points[0].p;
    }
    bringToFront() {
        const shape = this.getShape();
        if (shape)
            shape.bringToFront();
    }
    sendToBack() {
        const shape = this.getShape();
        if (shape)
            shape.sendToBack();
    }
    protected buildOverrides(): {} {
        return null;
    }
    protected get cacheKey(): string {
        return this.toolType;
    }
    clear() {

        this.tx = null;
        if (this.id != null) {
            if (this.tvd.isTvReady()) {
                //console.log(`clear ${this.id}, ${this.cachable}, ${this.cacheKey}`);
                if (!this.cachable || this.editable) {
                    this.tvd.tv.activeChart().removeEntity(this.id, { disableUndo: true });
                    this.id = null;
                    return;
                }
                const key = this.cacheKey;
                let list = this.tvd.shapesCache.get(key);
                if (!list)
                    this.tvd.shapesCache.set(key, list = []);
                const shape = this.getShape();
                if (shape) {
                    list.push({
                        id: this.id,
                        shape: shape
                    });
                    shape.setProperties({ 'visible': false });
                }
                this.id = null;
            }
            else {
                console.log('opps, ' + this.toolType + '_' + this.id + ' lost html context.');
            }
        }
    }

    private createFromCache(npts: TradingView.ShapePoint[]): TradingView.ILineDataSourceApi {
        if (!this.cachable || this.editable)
            return null;
        let list = this.tvd.shapesCache.get(this.cacheKey);
        let shapeInfo = list?.pop();
        let counts = 0;
        // console.log(`create ${this.id}, ${this.cachable}, ${this.cacheKey}`);
        while (shapeInfo != null) {
            this.id = shapeInfo.id;
            let pts: PricedPoint[] = null;
            try {
                pts = shapeInfo.shape.getPoints();
            } catch { }
            if (pts == null || pts.length == 0) {
                try {
                    this.tvd.tv.activeChart().removeEntity(this.id, { disableUndo: true });
                } catch { }
                this.id = null;
                counts++;
                shapeInfo = list?.pop();
            } else {
                break;
            }
        }
        //if (counts > 0)
        //    console.log(`cleaned ${counts} objects of ${this.toolType}`);
        if (!shapeInfo)
            return null;
        shapeInfo.shape.setProperties(this.buildOverrides());
        shapeInfo.shape.setPoints(npts);
        if (this.hasLabels)
            shapeInfo.shape.setProperties({ 'visible': true, showLabel: false });
        else
            shapeInfo.shape.setProperties({ 'visible': true });
        shapeInfo.shape.bringToFront();
        return shapeInfo.shape;
    }

    protected createShape(pt: tvpoint) {
        const pts = [toTvPt(pt)];
        let shape = this.getShape();
        if (!shape) {
            if (!this.createFromCache(pts))
                this.id = this.tvd.tv.activeChart().createShape(
                    pts[0],
                    this.getShapeParams()
                );
        }
        else {
            shape.setPoints(pts);
        }
    }

    protected createMultipointShape(pts: tvpoint[]) {
        const npts = pts.map(toTvPt);
        let shape = this.getShape();
        if (!shape) {
            if (!this.createFromCache(npts))
                this.id = this.tvd.tv.activeChart().createMultipointShape(
                    npts,
                    this.getShapeParams()
                );
        }
        else {
            try {
                shape.setPoints(npts);
            } catch (e) {
                if (!this.createFromCache(npts))
                    this.id = this.tvd.tv.activeChart().createMultipointShape(
                        npts,
                        this.getShapeParams()
                    );
            }
        }
    }
}

export class colorTool extends dTool {
    color: string;
    textColor: string;
    constructor(tt: TradingView.SupportedLineTools, tv: TVContext, color: string, textColor: string = null) {
        super(tt, tv);
        this.setColor(color, textColor);
    }
    setColor(color: string, textColor: string = null) {
        this.color = color;
        this.textColor = textColor == null ? color : textColor;
        this.setProperties({ linecolor: this.color, textcolor: this.textColor });
    }
}
export class lineTool extends colorTool {
    width: LineWidth;
    fontSize: number;
    lineStyle: LineStyle;
    valign: string;
    halign: string;
    constructor(tt: TradingView.SupportedLineTools, tv: TVContext, color: string, width: LineWidth, lineStyle: LineStyle = LineStyle.solid, textColor: string = null) {
        super(tt, tv, color, textColor);
        this.width = width;
        this.lineStyle = lineStyle;
        this.setAligns(valign_bottom, halign_right);

    }
    setAligns(valign: string, halign: string, fontSize: number = 10, updateProps: boolean = false) {
        this.valign = valign;
        this.halign = halign;
        this.fontSize = fontSize;

        if (updateProps)
            this.setProperties({
                horzLabelsAlign: this.halign,
                vertLabelsAlign: this.valign,
                fontsize: this.fontSize
            });
    }

    protected override buildOverrides(): {} {
        const obj = {
            bold: false,
            italic: false,
            linestyle: this.lineStyle,
            linecolor: this.color,
            linewidth: this.width,
            fontsize: this.fontSize,
            textcolor: this.textColor,
            horzLabelsAlign: this.halign,
            vertLabelsAlign: this.valign,

        } as any as TradingView.TrendangleLineToolOverrides;

        this.fillOverrides(obj);
        return obj;
    }

    protected fillOverrides(obj: any) {
    }
}

export class crossLineTool extends lineTool {
    showPrice: boolean = true;
    showTime: boolean = true;
    constructor(tv: TVContext, color: string, width: LineWidth, lineStyle: LineStyle = LineStyle.solid) {
        super('cross_line', tv, color, width, lineStyle);

    }
    build(pt: tvpoint) {
        this.createMultipointShape([pt]);
    }

    protected override fillOverrides(obj: any): void {
        obj.showTime = this.showTime;
        obj.showPrice = this.showPrice;
    }
}
export class vlTool extends lineTool {
    showPrice: boolean = true;
    constructor(tv: TVContext, color: string, width: LineWidth, editable = false, lineStyle: LineStyle = LineStyle.solid, textColor: string = null) {
        super("vertical_line", tv, color, width, lineStyle, textColor);
        this.editable = editable;
    }
    build(pt: tvpoint) {
        this.createShape(pt);
    }
    protected override buildOverrides(): {} {
        const obj = {
            bold: false,
            italic: false,
            linestyle: this.lineStyle,
            linecolor: this.color,
            linewidth: this.width,
            fontsize: this.fontSize,
            textcolor: this.textColor,
            horzLabelsAlign: this.halign,
            vertLabelsAlign: this.valign,
            textOrientation: "horizontal",
            showTime: this.showPrice,
            showLabel: this.showPrice,
        } as any as TradingView.VertlineLineToolOverrides;

        this.fillOverrides(obj);
        return obj;
    }
}
export class hlTool extends vlTool {
    constructor(tv: TVContext, color: string, width: LineWidth, editable = false, lineStyle: LineStyle = LineStyle.solid, textColor: string = null) {
        super(tv, color, width, editable, lineStyle, textColor);
        this.toolType = 'horizontal_line';
    }
    protected override fillOverrides(obj: any): void {
        delete obj.showTime;
        obj.showPrice = this.showPrice;
    }
}
export class hrTool extends lineTool {
    private showPrice: boolean;
    constructor(tv: TVContext, color: string, width: LineWidth, editable = false, lineStyle: LineStyle = LineStyle.solid, textColor: string = null, showPrice = true) {
        super('horizontal_ray', tv, color, width, lineStyle, textColor);
        this.editable = editable;
        this.fontSize = 14;
        this.showPrice = showPrice;
    }
    protected override fillOverrides(r: any) {
        super.fillOverrides(r);
        r.showPrice = this.showPrice;
        r.showLabel = this.showPrice;
        return r;
    }
    build(pt: tvpoint) {
        this.createShape(pt);
    }
}
export class rectTool extends colorTool {
    width: LineWidth;
    fill: boolean;
    valign: string;
    halign: string;
    forceLine: boolean;
    fontSize: number;
    constructor(tv: TVContext, color: string, width: LineWidth, textColor: string = null, fill = true, editable = false, forceLine = false) {
        super("rectangle", tv, color, textColor);
        this.setAligns(valign_top, halign_right);
        this.width = width;
        this.fill = fill;
        this.editable = editable;
        this.forceLine = forceLine;
    }
    override setColor(color: string, textColor: string = null) {
        this.color = color;
        this.textColor = textColor == null ? color : textColor;
        this.setProperties({
            backgroundColor: this.fill ? this.color : color_transparent,
            color: this.fill && !this.forceLine ? color_transparent : this.color,
            textColor: this.textColor
        });
    }
    setAligns(valign: string, halign: string, fontSize: number = 10) {
        this.valign = valign;
        this.halign = halign;
        this.fontSize = fontSize;
    }
    protected override buildOverrides() {
        return {
            vertLabelsAlign: this.valign,
            horzLabelsAlign: this.halign,
            linewidth: this.width,
            textColor: this.textColor,
            italic: false,
            backgroundColor: this.fill ? this.color : color_transparent,
            color: this.fill && !this.forceLine ? color_transparent : this.color,
            fontSize: this.fontSize,
            middleLine: {
                showLine: false
            },
            extendLeft: false,
            extendRight: false
        } as any as TradingView.RectangleLineToolOverrides;
    }
    build(pt0: tvpoint, pt1: tvpoint) {
        this.createMultipointShape([pt0, pt1]);
    }
    buildFromPts(pts: tvpoint[]) {
        this.createMultipointShape(pts);
    }

}
export class textTool extends dTool {
    size: number;
    color: string;
    txt: string;
    //valign: string;
    //halign: string;
    constructor(tv: TVContext, color: string, size = 14) {
        super("text", tv);
        this.setColor(color);
        /*this.setAligns(valign_center, halign_center);*/
        this.size = size;
    }
    setColor(color: string) {
        this.color = color;
        this.setProperties({ color: this.color });
    }
    protected override buildOverrides() {
        return {
            drawBorder: false,
            bold: false,
            italic: false,
            wordWrap: false,
            fixedSize: true,
            fillBackground: false,
            fontsize: this.size,

            font: 'verdana',
            text: this.txt,
            //vertLabelsAlign: this.valign,
            //horzLabelsAlign: this.halign,
            //backgroundColor: color_transparent,
            color: this.color
        };
    }
    build(pt: tvpoint, txt: string) {
        this.txt = txt;
        const shape = this.getShape();
        this.createShape(pt);
        const newshape = this.getShape();
        if (newshape)
            this.setText(txt);
    }
}
export class tlTool extends lineTool {
    constructor(tv: TVContext, color: string, width: LineWidth, textColor = '#000000', lineStyle: LineStyle = LineStyle.solid, fontSize: number = 12) {
        super("trend_line", tv, color, width, lineStyle, textColor);
        this.fontSize = fontSize;
    }
    override fillOverrides(obj: any) {
        obj.showBarsRange = false;
        obj.showMiddlePoint = false;
        obj.showPercentPriceRange = false;
        obj.showPriceLabels = false;
        obj.showPriceRange = false;
        obj.statsPosition = 0;
        obj.alwaysShowStats = false;
        obj.extendLeft = false;
        obj.extendRight = false;
        obj.leftEnd = 0;
        obj.rightEnd = false;
        return obj;
    }

    build(pt0: tvpoint, pt1: tvpoint) {
        this.createMultipointShape([pt0, pt1]);
    }

}

export class pTool extends dTool {
    width: LineWidth;
    color: string;
    linestyle: LineStyle;
    constructor(tv: TVContext, color: string, width: LineWidth, linestyle: LineStyle = LineStyle.solid) {
        super("path", tv);
        this.setColor(color);
        this.width = width;
        this.linestyle = linestyle;
        this.cachable = false;
    }
    setColor(color: string) {
        this.color = color;
        this.setProperties({ linecolor: this.color });
    }
    protected override buildOverrides() {
        return {
            leftEnd: 0,
            lineColor: this.color,
            lineStyle: this.linestyle,
            lineWidth: this.width,
            rightEnd: 0
        };
    }
    build(pts: Array<tvpoint>, from: number, to: number) {
        const dpts = new Array<tvpoint>();
        //const tapi = this.tv.activeChart().getTimeScale();
        dpts.length = (to - from);
        for (let i = from; i < to; i++) {
            const j = i - from;
            dpts[j] = pts[i];
        }
        this.clear();
        if (dpts.length > 0)
            this.createMultipointShape(dpts);
    }
}

export class plTool extends dTool {
    color: string;
    bgcolor: string;
    width: LineWidth;
    constructor(tv: TVContext, color: string, width: LineWidth) {
        super("polyline", tv);
        this.setColor(color);
        this.width = width;
        this.cachable = false;
    }
    setColor(color: string) {
        this.color = color;
        this.bgcolor = color;
        this.setProperties({ backgroundColor: this.bgcolor, linecolor: this.color });
    }
    protected override buildOverrides() {
        return {
            filled: false,
            linewidth: this.width,
            backgroundColor: this.bgcolor,
            linecolor: this.width == LineWidth.w0 ? color_transparent : this.color
        };
    }

    buildByPivots(dpts: tvpoint[]) {
        this.clear();
        this.createMultipointShape(dpts);
    }

    build(pts: tvbar[], from: number = null, to: number = null) {
        if (from == null)
            from = 0;
        if (to == null)
            to = pts.length;
        const dpts: tvpoint[] = [];

        dpts.length = (to - from) * 2;
        for (let i = from; i < to; i++) {
            const p = pts[i];
            const j = i - from;
            dpts[j] = { t: p.t, p: p.h };
            dpts[dpts.length - 1 - j] = { t: p.t, p: p.l };
        }
        if (dpts.length > 0)
            this.buildByPivots(dpts);
    }
}

export enum IconId {
    Arrow = 0xf106,
    VirtArrow = 0xf077,
    Triangle = 0xf0d8,
    VirtTriangle = 0xf0d8,// 0xf04b,
    VirtCircle = 0xf10c,
    Circle = 0xf111,
}
export enum defaultIconSize {
    Small = 4,
    Medium = 8,
    Big = 14,
}
export class iconTool extends dTool {
    color: string;
    size: number;
    iconId: IconId;
    rotate: boolean;
    fixedColor: string = null;
    constructor(tv: TVContext, color = '#000000', size = 40, id: IconId = IconId.Circle, rotate = true) {
        super("icon", tv);
        this.setColor(color);
        this.size = size;
        this.iconId = id;
        this.rotate = rotate;
        this.hasLabels = false;
    }
    setColor(color: string) {
        this.color = this.fixedColor ?? color;
        this.setProperties({ color: this.color });
    }
    protected override get cacheKey() {
        return this.toolType + IconId[this.iconId];
    }
    protected override buildOverrides() {
        let angle = this.rotate ? -Math.PI / 2 : Math.PI / 2;
        return {
            color: this.color,
            size: this.size,
            angle: angle,
            icon: this.iconId
        };
    }
    build(pt: tvpoint) {
        this.createShape(pt);
    }
}
